import { api } from './api';

/**
 * The review surface is workspace-scoped but the reviewer thinks in "my queue".
 * These helpers merge every workspace the user can see into one list — used by
 * the global /review picker and the sidebar pending-count badge. No dedicated
 * count endpoint exists yet, so this fans out client-side; fine at the current
 * scale (a handful of companies), revisit if that changes.
 */
export interface ReviewWorkspace {
  id: string;
  name: string;
  companyName: string;
  companySlug: string;
}

export async function fetchReviewWorkspaces(): Promise<ReviewWorkspace[]> {
  const companies = await api.listCompanies();
  const details = await Promise.all(companies.map((c) => api.getCompany(c.id).catch(() => null)));
  return details
    .filter((d): d is NonNullable<typeof d> => d !== null)
    .flatMap((d) => d.workspaces.map((w) => ({ id: w.id, name: w.name, companyName: d.name, companySlug: d.slug })));
}

/** Total PENDING suggestions the caller can review — one aggregate request. */
export async function fetchPendingReviewCount(): Promise<number> {
  const { count } = await api.getPendingReviewCount().catch(() => ({ count: 0 }));
  return count;
}
